// extracted by mini-css-extract-plugin
export default {"card":"BlogCard_card__YJStR","cardContent":"BlogCard_cardContent__JOzeN","more":"BlogCard_more__2+vpt","overlay":"BlogCard_overlay__2Ig5K","bg":"BlogCard_bg__qKJed"};